import React, { useState } from "react"
import StarRatings from "react-star-ratings"
import Navbar from "../Components/navbar"
import Footer from "../Components/footer"
import { Container, Row, Col, Card } from "react-bootstrap"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import "../Styles/musicpage.scss"
//player
import AudioPlayer from "react-h5-audio-player"
import "react-h5-audio-player/src/styles.scss"
// icons import:
import { BsPersonFill, BsFileEarmarkText } from "react-icons/bs"
import { IoIosMusicalNotes } from "react-icons/io"
import { FaShareSquare, FaEye, FaDownload } from "react-icons/fa"
import { AiOutlineFullscreenExit } from "react-icons/ai"

const Musictemp = ({ data }) => {
  const [lyrics, setLyrics] = useState(false)
  const music = data.mdata.frontmatter
  return (
    <div className="musicpage">
      <div id="lyrics" className={lyrics ? "lyricson" : "lyricsoff"}>
        <AiOutlineFullscreenExit
          className="exitlyrics"
          onClick={() => {
            setLyrics(false)
          }}
        />
        <div className="lyricfield">
          <h1>{music.title}</h1>
          <br />
          <div
            className="single-post-txt"
            dangerouslySetInnerHTML={{ __html: data.mdata.html }}
          />
        </div>
      </div>
      <Navbar />
      <div>
        <AudioPlayer
          className="musicpage-musicplayer"
          autoPlay
          src={music.music360}
          onPlay={e => console.log("onPlay")}
          // other props here
        />
      </div>
      <Container className="musicpage-body">
        <Row>
          <Col xl="12">
            <Card className="musicdetail-card">
              <Card.Body className="musicdetail-card">
                <Row>
                  <Col md="5">
                    <Row>
                      <Col md="12">
                        <div className="music-image-div">
                          <Img
                            alt={music.title}
                            className="music-image"
                            fluid={music.image.childImageSharp.fluid}
                          />
                          <div className="middle">
                            <Col className="middle-items">
                              <ul>
                                <li className="middle-items-icon">
                                  <FaShareSquare />
                                </li>
                                <li className="middle-items-txt">
                                  <small>&nbsp;Share</small>
                                </li>
                              </ul>
                            </Col>
                            <Col
                              className="middle-items"
                              onClick={() => {
                                setLyrics(true)
                              }}
                            >
                              <ul>
                                <li className="middle-items-icon">
                                  <BsFileEarmarkText />
                                </li>
                                <li className="middle-items-txt">
                                  <small>&nbsp;Lyric</small>
                                </li>
                              </ul>
                            </Col>
                            <Col className="middle-items">
                              <ul>
                                <li className="middle-items-icon">
                                  <BsPersonFill />
                                </li>
                                <li className="middle-items-txt">
                                  <small>&nbsp;Artist</small>
                                </li>
                              </ul>
                            </Col>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="7" className="musicinfo">
                    <span className="musicinfo-date">
                      <p></p>
                      <small>{music.date}</small>
                    </span>
                    <Row>
                      <Col sm="12">
                        <div className="musicinfo-1">
                          <Card.Subtitle>
                            <ul>
                              <li>
                                <IoIosMusicalNotes
                                  className="musicinfo-trackname"
                                  size="2.5em"
                                ></IoIosMusicalNotes>
                              </li>
                              <li>
                                <h1 className="musicinfo-trackname">
                                  {music.title}
                                </h1>
                              </li>
                            </ul>
                          </Card.Subtitle>
                          <Card.Subtitle>
                            <ul>
                              <li>
                                <BsPersonFill
                                  className="musicinfo-artistname"
                                  size="2.5em"
                                ></BsPersonFill>
                              </li>
                              <li>
                                <Link className="musicinfo-artistname">
                                  <h3 style={{ marginRight: ".5em" }}>
                                    {music.artist}
                                  </h3>
                                </Link>
                              </li>
                            </ul>
                          </Card.Subtitle>
                        </div>
                      </Col>
                      <Col sm="12">
                        <div className="musicinfo-2">
                          <div>
                            <ul>
                              <li>
                                <p className="musicinfo-poet">
                                  {" "}
                                  ترانه‌سرا: &nbsp;
                                </p>
                              </li>
                              <li>
                                <Link className="musicinfo-poet">
                                  <p className="musicinfo-poet link-trans">
                                    {music.poet}
                                  </p>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <ul>
                              <li>
                                <p className="musicinfo-composer">
                                  تنظیم کننده: &nbsp;
                                </p>
                              </li>
                              <li>
                                <Link className="musicinfo-composer">
                                  <p className="musicinfo-composer link-trans2">
                                    {music.composer}
                                  </p>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <ul>
                              <li>
                                <p className="musicinfo-musicmaker">
                                  آهنگ‌ساز: &nbsp;
                                </p>
                              </li>
                              <li>
                                <Link className="musicinfo-musicmaker">
                                  <p className="musicinfo-musicmaker  link-trans">
                                    {music.piece}
                                  </p>
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <ul>
                              <li>
                                <p className="musicinfo-mixmaster">
                                  میکس و مستر: &nbsp;
                                </p>
                              </li>
                              <li>
                                <Link className="musicinfo-mixmaster">
                                  <p className="musicinfo-mixmaster link-trans2">
                                    {music.mixmaster}
                                  </p>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </Col>
                      <div className="download-btn">
                        <Col>
                          <Row>
                            <Col md="6">
                              <a href={music.music120} target="_blank">
                                <div className="badge download120 badge-success">
                                  <ul>
                                    <li>
                                      <FaDownload />
                                    </li>
                                    <li>
                                      <p>دانلود آهنگ با کیفیت 128</p>
                                    </li>
                                  </ul>
                                </div>
                              </a>
                            </Col>
                            <Col md="6">
                              <a href={music.music360} target="_blank">
                                {" "}
                                <div className="badge download360 badge-primary">
                                  <ul>
                                    <li>
                                      <FaDownload />
                                    </li>
                                    <li>
                                      <p>دانلود آهنگ با کیفیت 320</p>
                                    </li>
                                  </ul>
                                </div>
                              </a>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                    </Row>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col md="12">
            <Row className="music-options">
              <Col sm={6} xs={12} className="music-options-rate">
                <StarRatings
                  rating={2.25}
                  numberOfStars={3}
                  starRatedColor="rgb(214, 211, 6)"
                  svgIconPath="M18,3l4.635,9.39L33,13.9l-7.5,7.3,1.77,10.32L18,26.655,8.73,31.53,10.5,21.21,3,13.9,13.365,12.39Z"
                />
              </Col>

              <Col sm={6} xs={12} className="music-options-view">
                <ul>
                  <li>
                    <FaEye />
                  </li>
                  <li>
                    <small>&nbsp;{music.view}</small>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
          <Col xl="12">
            <Card className="other-musics">
              <Row>
                <Col md="12">
                  <div className="other-musics-artist">
                    <div className="other-musics-artist-title-div">
                      <ul className="other-musics-artist-title">
                        <li>
                          <p className="other-musics-artist-title-txt">
                            آهنگ‌های بیشتر از:&nbsp;
                          </p>
                        </li>
                        <li>
                          <p className="other-musics-artist-title-artist">
                            {music.artist}
                          </p>
                        </li>
                      </ul>
                    </div>

                    <div className="other-musics-divider"></div>
                  </div>
                </Col>
                <Col md="12">
                  <div className="other-musics-new">
                    <div>
                      <p className="other-musics-new-title">جدیدترین آهنگ‌ها</p>
                    </div>

                    <div className="other-musics-divider"></div>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
      <div style={{ height: "5.5em" }}></div>
    </div>
  )
}
export const musicQuery = graphql`
  query musicPostBySlug($slug: String!) {
    mdata: markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      frontmatter {
        title
        date
        artist
        music120
        music360
        view
        mixmaster
        poet
        piece
        rate
        composer
        image {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      fields {
        slug
      }
      excerpt(truncate: true)
    }
  }
`
export default Musictemp
